import { call, put, select } from 'redux-saga/effects';
import { getByName as getByNameAda } from '@bitComponents/adabyronCloud/customizer';
import { WEB_SERVICES } from './webServices';

const contextStore = state => state.context.data;

export function* getByName(params) {
  const {
    normalizeHttpErrors,
    name,
    reduxUpdate,
    custoType,
  } = params;
  try {
    const context = yield select(contextStore);
    const getByNameParams = {
      context,
      name,
    };

    const { successUpdate } = reduxUpdate;

    const response = yield call(getByNameAda, getByNameParams, custoType);

    if (response && response.response && successUpdate) {
      yield put(successUpdate(response.response));
    }

    return response.response;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.CUSTOMIZER_ACTIVITY_GET_BY_NAME, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
